import styled from "styled-components"
import { TextDiv } from "../common/Text"
import { StyledButton } from "../common/Buttons"
import { useInView } from "framer-motion"
import { useRef } from "react"
import { useNavigate } from "react-router-dom"

const SubContent = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  const navigate = useNavigate()
  return (
    <Container>
      <DescriptionContainer ref={ref}>
        <DescriptionBox>
          <Description className="box1" $isInView={isInView}>
            <DescriptionTitle color="var(--custom-deep-dark-brown)">
              학문프로파일
            </DescriptionTitle>
            <DescriptionContent>
              <div>
                <DescriptionText>
                  109개 학과의 학문적 특징을 지식, 역량, 흥미, 가치, 개인특성
                  별로 정리
                </DescriptionText>
                <DescriptionText>
                  서울대학교, 연세대학교, 고려대학교 등에 재학중인 약 100인의
                  학부생 및 대학원생이 제작
                </DescriptionText>
                <DescriptionText>
                  약 100인의 대학교수가 학문프로파일 내용 검토
                </DescriptionText>
              </div>
              <GifContainer src="./img/search.gif" alt="#" />
            </DescriptionContent>
          </Description>
        </DescriptionBox>
        <DescriptionBox>
          <Description className="box2" $isInView={isInView}>
            <DescriptionTitle color="var(--custom-deep-dark-brown)">
              진단 알고리즘
            </DescriptionTitle>
            <DescriptionContent>
              <div>
                <DescriptionText>
                  자연어처리기법을 활용한 학문프로파일의 학과별 학문적성 정보량
                  계산
                </DescriptionText>
                <DescriptionText>
                  피험자의 학문적성이 높은 순서대로 상위 3개 학과 제시
                </DescriptionText>
              </div>
              <GifContainer src="./img/algorithm.gif" alt="#" />
            </DescriptionContent>
          </Description>
        </DescriptionBox>
      </DescriptionContainer>
      <ButtonContainer $isInView={isInView}>
        <IconButton
          $activeColor="var(--custom-platinum)"
          $hoverColor="var(--custom-platinum)"
          $activeTextColor="var(--custom-deep-dark-brown)"
          onClick={() => navigate("/quiz")}
        >
          <Icon src={process.env.PUBLIC_URL + "/img/test.png"} alt="" />
          검사하러 가기
        </IconButton>
      </ButtonContainer>
    </Container>
  )
}

export default SubContent

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
  padding-bottom: 80px;
  box-sizing: border-box;
  gap: 30px;
  position: relative;
`

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;

  @media ${({ theme }) => theme.device.pc} {
    width: 70%;
  }
`

const DescriptionBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media ${({ theme }) => theme.device.pc} {
    // width: 50%;
  }
`

const Description = styled.div<{ $isInView: boolean }>`
  width: 85%;
  border-radius: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),
    0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),
    0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);
  padding: 10px;
  box-sizing: border-box;
  position: relative;

  @media ${({ theme }) => theme.device.pc} {
    padding: 20px 30px;
  }

  &.box1 {
    transform: ${(props) => (props.$isInView ? "none" : "translateX(-100px)")};
    opacity: ${(props) => (props.$isInView ? 1 : 0)};
    transition-property: transform, opacity;
    transition-duration: 0.6s;
    transition-timing-function: ease-in-out;
    transition-delay: 0.5s;

    @media ${({ theme }) => theme.device.pc} {
      transform: ${(props) => (props.$isInView ? "none" : "translateX(-30px)")};
    }
  }

  &.box2 {
    transform: ${(props) => (props.$isInView ? "none" : "translateX(-100px)")};
    opacity: ${(props) => (props.$isInView ? 1 : 0)};
    transition-property: transform, opacity;
    transition-duration: 0.6s;
    transition-timing-function: ease-in-out;
    transition-delay: 0.8s;

    @media ${({ theme }) => theme.device.pc} {
      transform: ${(props) => (props.$isInView ? "none" : "translateX(-30px)")};
    }
  }
`

const DescriptionTitle = styled(TextDiv)`
  text-align: start;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;

  @media ${({ theme }) => theme.device.pc} {
    font-size: 40px;
  }
`

const DescriptionContent = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
`

const DescriptionText = styled(TextDiv)`
  text-align: start;
  font-size: 12px;
  color: var(--custom-light-brown);
  margin-bottom: 10px;

  @media ${({ theme }) => theme.device.pc} {
    font-size: 16px;
  }
`

const GifContainer = styled.img`
  align-self: flex-end;
  width: 25%;
  object-fit: contain;
`

const ButtonContainer = styled.div<{ $isInView: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 45px;
  box-sizing: border-box;
  padding: 30px 50px;

  transform: ${(props) => (props.$isInView ? "scale(1)" : "scale(0.9)")};
  opacity: ${(props) => (props.$isInView ? 1 : 0)};
  transition-property: transform, opacity;
  transition-duration: 0.6s;
  transition-timing-function: ease-in-out;
  transition-delay: 1.2s;

  @media ${({ theme }) => theme.device.pc} {
    width: 40%;
    padding: 30px 0px;
  }
`

const IconButton = styled(StyledButton)`
  height: 65px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0px 20px;
  border-radius: 25px;
  font-size: 20px;
  color: var(--custom-deep-dark-brown);

  @media ${({ theme }) => theme.device.pc} {
    height: 80px;
    width: 80%;
    padding: 0px 30px;
    font-size: 28px;
  }
`

const Icon = styled.img`
  height: 35px;
  width: 35px;
  object-fit: contain;

  @media ${({ theme }) => theme.device.pc} {
    height: 40px;
    width: 40px;
  }
`
